import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=48b44fff&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=48b44fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b44fff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b44fff')) {
      api.createRecord('48b44fff', component.options)
    } else {
      api.reload('48b44fff', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=48b44fff&scoped=true&", function () {
      api.rerender('48b44fff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25sdy7AQ8rsNt/JS/teamMember.vue"
export default component.exports